export const pxToNumber = (value: string) => Number(value.replace('px', ''));

export const numberToPx = (value: number) => `${value}px`;
